export default {
    modalQuickActionVariations: {
        title: 'IA',
        generateWithAi: 'Gerar com AI',
        improveWriting: 'Melhore a escrita',
        fixSpelling: 'Corrigir ortografia e gramática',
        simplifyWriting: 'Simplificar a escrita',
        makeLonger: 'Aumentar',
        makeShorter: 'Encurtar',
        replaceText: 'Substitua o texto',
        addBelow: 'Adicionar abaixo',
        cancel: 'Cancelar',
        selectQuickActionTitle: 'Diga à IA o que fazer em seguida...',
        regenerate: 'Regenerar',
    },
};
